// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__98HT_","badges":"styles_badges__Dlpr4"};